import React from 'react'
import { TextStyle } from 'react-native'
import { TextChildren, VoidFunction } from 'lib/types'
import { createStyles, useStyles } from 'lib/styles'
import { BaseText } from './BaseText'

type HeadingProps = {
    numberOfLines?: number,
    onPress?: VoidFunction,
    style?: TextStyle,
    forceColor?: string,
    children?: TextChildren
}

export const Heading: React.FunctionComponent<HeadingProps> = ({
    children,
    numberOfLines,
    onPress,
    style = {},
    forceColor
}) => {
    const { styles } = useStyles(stylesheet)

    return (
        <BaseText
            onPress={onPress}
            style={{
                ...styles.text,
                ...style
            }}
            numberOfLines={numberOfLines}
            forceColor={forceColor}
            children={children}
        />
    )
}

const stylesheet = createStyles(theme => ({
    text: {
        ...theme.typography.heading,
        ...theme.components.typography.primary,
        fontSize: {
            xs: 28,
            sm: 32
        },
        lineHeight: {
            xs: 36,
            sm: 42
        }
    }
}))
